import script from "./TranslationProgressReport.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationProgressReport.vue?vue&type=script&setup=true&lang=js"

import "./TranslationProgressReport.vue?vue&type=style&index=0&id=71a290de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a290de"]])

export default __exports__